import { useEffect, useState } from 'react';

import { getConfigValue } from 'utils/environment';

declare global {
  interface Window {
    // TO DO: This will be updated with GQL changes
    AdyenCheckout: any;
  }
}

type ErrorState = ErrorEvent | null;

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

export const useAdyenScript = () => {
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<ErrorState>(null);

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    const baseUrl = getConfigValue('adyen').urlPrefix;

    const existing = document.querySelectorAll(
      `script[src="${baseUrl}/checkoutshopper/sdk/3.17.0/adyen.js"]`
    );

    if (existing.length > 0) {
      setLoading(false);
      return;
    }

    const handleLoad = () => {
      setLoading(false);
      setLoaded(true);
    };

    const handleError = (err: ErrorState) => {
      setLoading(false);
      setLoaded(false);
      setError(err);
    };

    const script = document.createElement('script');
    // TO DO: This will be updated to include live endpoints based on region.
    script.src = `${baseUrl}/checkoutshopper/sdk/3.17.0/adyen.js`;
    script.integrity = 'sha384-G9jkTAyCOIVdksXbtrNgdur2DyRi85ujYLXbqe5AvvH23rN21d7xiU7cRIqvsEaH';
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    // Standard Adyen card input styles
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    // TO DO: This will be updated to include live endpoints based on region.
    link.href = `${baseUrl}/checkoutshopper/sdk/3.17.0/adyen.css`;
    link.integrity = 'sha384-gbQyzqV1xX+snFEMrubEm0IpmYSufBjUnHzTaJZ+dcWCyxl0j94IZhnfC2gbxgeu';
    link.crossOrigin = 'anonymous';

    document.body.appendChild(script);
    document.body.appendChild(link);

    return () => {
      document.body.removeChild(script);
      document.body.removeChild(link);
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
  }, []);

  return { loaded, loading, error };
};
